// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"4526a914","4239":"a21376f4"}[chunkId] + ".chunk.css";
};